import axios from "axios";
const BASEURL = "https://anmapi.defconinnovations.com"; // 🔁 change this
const api = axios.create({
  baseURL: BASEURL, // 🔁 change this
  headers: {
    "Content-Type": "application/json",
  },
});

export const loginApi = (data) => api.post("/api/auth/login/", data);
export const registerApi = (data) => api.post("/api/auth/register/", data);

export default api;
